
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"-5 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.28 53.022h-7.363a1.876 1.876 0 000 3.75h7.363a1.876 1.876 0 000-3.75z"}}),_c('path',{attrs:{"d":"M49.785 16.657h-4.213V7.215C45.572 3.237 42.335 0 38.357 0H12.84C8.862 0 5.625 3.237 5.625 7.215v49.57C5.625 60.763 8.862 64 12.84 64h25.517c3.978 0 7.215-3.237 7.215-7.215V40.762h4.213c4.717 0 8.555-3.838 8.555-8.556v-6.994c0-4.717-3.838-8.555-8.555-8.555zM31.18 3.75v1.855H20.018V3.751h11.161zM41.82 56.785a3.467 3.467 0 01-3.463 3.464H12.84a3.467 3.467 0 01-3.464-3.464V7.215A3.467 3.467 0 0112.84 3.75h3.426V5.76a3.603 3.603 0 003.599 3.599h11.468a3.603 3.603 0 003.598-3.599V3.751h3.426a3.467 3.467 0 013.463 3.464v9.442h-9.542c-4.717 0-8.555 3.838-8.555 8.555v16.613c0 .861.474 1.642 1.238 2.04a2.296 2.296 0 002.222-.057l6.033-3.046h8.604v16.023zm12.77-24.578a4.81 4.81 0 01-4.805 4.804H32.861c-.412 0-.81.109-1.163.315l-4.224 2.133V25.212a4.81 4.81 0 014.804-4.804h17.507a4.81 4.81 0 014.804 4.804v6.994z"}}),_c('path',{attrs:{"d":"M49.238 23.36H32.825a1.876 1.876 0 000 3.751h16.413a1.876 1.876 0 000-3.751zM49.238 29.765h-8.206a1.875 1.875 0 100 3.752h8.206a1.876 1.876 0 000-3.752z"}})])
          )
        }
      }
    